module.exports = __webpack_public_path__ + "273de1f6aa59885ddefc080e87fb26d7.svg";